import { motion } from "framer-motion";

export function Reveal({ children, delay = 0, className = "", y = 28 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeading({ eyebrow, title, children, className = "" }) {
  return (
    <Reveal className={`max-w-3xl space-y-4 ${className}`}>
      {eyebrow && <p className="eyebrow">{eyebrow}</p>}
      <h2 className="h-display text-4xl text-white sm:text-5xl lg:text-6xl">{title}</h2>
      {children && <p className="text-sm leading-relaxed text-white/60 sm:text-base">{children}</p>}
    </Reveal>
  );
}

export function PageHero({ eyebrow, title, sub, image }) {
  return (
    <section className="grain relative overflow-hidden border-b border-white/10">
      {image && <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover opacity-30" fetchPriority="high" />}
      <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/70 to-[#0A0A0A]/30" />
      <div className="relative mx-auto max-w-7xl px-4 pb-14 pt-20 sm:px-8 sm:pb-20 sm:pt-28">
        <Reveal className="space-y-5">
          <p className="eyebrow">{eyebrow}</p>
          <h1 className="h-display text-5xl text-white sm:text-6xl lg:text-8xl" data-testid="page-title">{title}</h1>
          {sub && <p className="max-w-2xl text-base text-white/70 md:text-lg">{sub}</p>}
        </Reveal>
      </div>
    </section>
  );
}
